module.exports = __webpack_public_path__ + "img/layout_bottom_icon.4a861b22.svg";